import { get } from 'lodash';
import { connect } from 'react-redux';

import OurCommitmentModal from 'components/OurCommitmentModal';
import * as actions from 'state/actions';
import { MODAL_TYPES } from 'state/constants';

const mapStateToProps = state => {
  const isOpen = get(state, ['app', 'modal']) === MODAL_TYPES.OUR_COMMITMENT;

  return {
    isOpen,
  };
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(actions.closeModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OurCommitmentModal);
